import React from 'react'
import styled from 'styled-components'
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import ConclusionBar from '../ConclusionBar'
import Link from '@material-ui/core/Link';
import * as courseUtils from '../../utils/course'


const useStyles = makeStyles(theme => ({
    mainTitle: {
        color: '#FFF',
        fontSize: '20px',
        lineHeight: '28px',
        marginBottom: '8px'
    },
    subtitle: {
        color: '#FFF',
        fontSize: '16px',
        marginBottom: '8px'
    },
    linkBack: {
        color: '#FFF',
        textDecoration: 'underline',
        fontSize: '14px',
        marginTop: '16px',
        textAlign: 'right',
        display: 'block'
    }
}))

const TitleBlock = styled.div`
    max-width: 100%;
    padding: 16px;
    background-color: #4212E3;
`

const CourseTitleBlock = ({ course, currentContent, trails }) => {   
   
    const classes = useStyles();
    const contentList = courseUtils.getContentsFromTrails(trails)
    const currentContentTopic = ((contentList[contentList.findIndex(e => e._id === currentContent)] ||[]).titulo)
    return (
        <TitleBlock>
            <Typography variant="body1" component="h2" className={classes.mainTitle}>{(course|| {}).titulo}</Typography>
            <Typography variant="body2" component="h5" className={classes.subtitle}>{ (currentContentTopic || '').split('').map(letter => letter === '/' ? ' / ' : letter).join('') }</Typography>
            <ConclusionBar progress={(course || {}).progresso}/>
            <Typography >
                <Link href="/" className={classes.linkBack}>
                    Voltar para Meus Cursos
                </Link>
            </Typography>
        </TitleBlock>
    )
}

export default CourseTitleBlock